import type { AirHandlerTypeCodeType } from 'data/types';

const DUCTED_ONLY_AIR_HANDLER_CODES: ReadonlySet<string> = new Set([
  'ducted',
  'evap_coil'
]);

function isDuctedOnlyAirHandlerCode(code: string | null | undefined): boolean {
  return code != null && DUCTED_ONLY_AIR_HANDLER_CODES.has(code);
}

export type ZoneForDuctedAirHandlerFlag = {
  type?: string | null;
  airHandler?: { airHandlerTypeCode?: string | null } | null;
  zoneItems?: Array<{ structureItemId: string }>;
};

export function shouldRequireDuctedAirHandler(params: {
  emitDuctedZoneFlags: boolean;
  condenserType?: string | null;
  zone: ZoneForDuctedAirHandlerFlag;
  leftoverSpaceIds?: ReadonlySet<string>;
}): boolean {
  if (!params.emitDuctedZoneFlags) {
    return false;
  }
  if (params.condenserType === 'ducted') {
    return false;
  }
  const placedIsDuctedOnly = isDuctedOnlyAirHandlerCode(
    params.zone.airHandler?.airHandlerTypeCode
  );
  if (params.zone.type === 'ducted' || placedIsDuctedOnly) {
    return true;
  }
  const leftoverIds = params.leftoverSpaceIds;
  const items = params.zone.zoneItems;
  if (!leftoverIds || !items || items.length === 0) {
    return false;
  }
  return items.every((item) => leftoverIds.has(item.structureItemId));
}

export function catalogSelectedAirHandlerType(
  placedType: string | null | undefined
): AirHandlerTypeCodeType | null {
  if (placedType == null) return null;
  if (isDuctedOnlyAirHandlerCode(placedType)) return 'ducted';
  return placedType as AirHandlerTypeCodeType;
}
